<!--
	日期：2025/08/25
	地点：四川 成都
	作者：终结司令官
	
	介绍：左侧菜单显示区
	
	- Powered by finalcommander.com
	- Supported by IOE.TOP
	
	el-menu-vertical-demo custom-menu el-menu
-->
<template>
	<div id="aside-container" class="aside-container">
		<el-row id="aside-container-menu" class="aside-container-menu" @click.native="mainAside_click">
		<el-menu
		  default-active="2"
		  class="el-menu-vertical-demo custom-menu"
		  @open="handleOpen"
		  @close="handleClose"
		  :collapse="isCollapse"
		  background-color="#1e293b"
		  text-color="#cbd5e1"
		  active-text-color="#3b82f6">
			<el-menu-item 
				@click="hiddenMenu"
				:style="{
				textAlign: isCollapse ? 'center' : '',
				minWidth: isCollapse ? '' : '200px',
				}"
				class="menu-header-item">
				<i class="el-icon-set-up header-icon"></i>
					{{ isCollapse ? '' : '运营中心' }}
				<hr class="menu-divider">
			</el-menu-item>
			<!--
			<el-menu-item @click="navigateTo('/')" index="2">
				<i class="el-icon-s-home"></i>
				<span slot="title">首页</span>
			</el-menu-item>
			-->
			<!-- 
				不含有子项的菜单 
			-->
			<el-menu-item 
				@click="clickGoToPage(item)" 
				v-for="item in get_myMenus_noChildrenTop" 
				:key="item.name" 
				:index="item.name"
				class="custom-menu-item">
				<i :class="`el-icon-${item.icon} menu-icon`"></i>
				<span slot="title" class="menu-text">{{item.meta.label}}</span>
				<!-- <router-link :to="`${item.path}`" style="color:#336699;">{{item.label}}</router-link> -->
			</el-menu-item>
			<!-- 
				含有子项的菜单 
			-->
			<el-submenu 
				v-for="item in get_myMenus_hasChildren" 
				:key="item.name" 
				:index="item.name"
				class="custom-submenu">
				<template slot="title">
					<i :class="`el-icon-${item.icon} menu-icon`"></i>
					<span slot="title" class="menutree-text">{{ item.meta.label }}</span>
				</template>
				<el-menu-item-group 
					v-for="subitem in item.children" 
					:key="subitem.name"
					class="submenu-group">
					<el-menu-item 
						@click="clickGoToPage(subitem)" 
						:index="subitem.name"
						class="submenu-item">
						<i :class="`el-icon-${subitem.icon} submenu-icon`"></i>
						<span slot="title" class="submenu-text">{{subitem.meta.label}}</span>
						<!-- <router-link :to="`${subitem.path}`" style="color:#336699;">{{subitem.label}}</router-link> -->
					</el-menu-item> 
				</el-menu-item-group>
			</el-submenu>
			<!-- 
				不含有子项的菜单 
			-->
			<el-menu-item 
				@click="clickGoToPage(item)" 
				v-for="item in get_myMenus_noChildren" 
				:key="item.name" 
				:index="item.name"
				class="custom-menu-item">
				<i :class="`el-icon-${item.icon} menu-icon`"></i>
				<span slot="title" class="menu-text">{{item.meta.label}}</span>
				<!-- <router-link :to="`${item.path}`" style="color:#336699;">{{item.label}}</router-link> -->
			</el-menu-item>
			<!--
			<el-menu-item @click="navigateTo('/m01')" index="2">
				<i class="el-icon-menu"></i>
				<span slot="title">M01</span>
			</el-menu-item>
			<el-menu-item index="3" disabled>
				<i class="el-icon-document"></i>
				<span slot="title">导航三</span>
			</el-menu-item>
			<el-menu-item @click="navigateTo('/m02')" index="4">
				<i class="el-icon-setting"></i>
				<span slot="title">M02</span>
			</el-menu-item>
			-->
		</el-menu>
		<div style="height:50px;"></div>
		</el-row>
		<div class="nulldiv" @click="nulldiv_click()"></div>
	</div>
</template>
<script>
import { switchTab } from '../utils/function.js'
import store from '../store'
import Cookies from 'js-cookie'

// 输出元素
export default {
	name: 'aside-container',
	props: ['userInfo','srceenWidth','srcWidth'],
	methods: {
		// 左侧菜单界面点击操作
		mainAside_click (event) {
			//return ;
			if(window.innerWidth > 600) return;
			
			if (!event.target.classList[0]) {
				//console.log('点击了匿名按0');
				document.getElementById("mainAside").classList.toggle('hidden');
			}
			/*else if (!event.target.classList.length == 0) {
				console.log('点击了空白2');
				document.getElementById("mainAside").classList.toggle('hidden');
			}*/
			// 点击了根目录按钮
			else if (event.target.classList.contains('custom-menu-item')) {
				//console.log('点击了根目录按钮');
				// 执行按钮相关的逻辑
				//document.getElementById("mainAside").classList.toggle('hidden');
			}
			// 点击了根目录文字
			else if (event.target.classList.contains('menu-text')) {
				//console.log('点击了根目录文字');
				document.getElementById("mainAside").classList.toggle('hidden');
			}
			// 点击了有子目录的根目录按钮
			else if (event.target.classList.contains('el-submenu__title')) {
				//console.log('点击了有子目录的根目录按钮');
			}
			// 点击了有子目录的根目录文字
			else if (event.target.classList.contains('menutree-text')) {
				//console.log('点击了有子目录的根目录文字');
			}
			// 点击了子目录的目录按钮
			else if (event.target.classList.contains('submenu-item')) {
				//console.log('点击了子目录的目录按钮');
			}
			// 点击了子目录的目录文字
			else if (event.target.classList.contains('submenu-text')) {
				//console.log('点击了子目录的目录文字');
				document.getElementById("mainAside").classList.toggle('hidden');
			}
			// 如果直接点击了div的空白处
			else {
				//console.log('点击了DIV空白处');
				// 执行DIV本身的逻辑，例如收起菜单等
				//document.getElementById("mainAside").classList.toggle('hidden');
			}
		},
		nulldiv_click()
		{
			document.getElementById("mainAside").classList.toggle('hidden');
		},
		handleOpen(key, keyPath) {
			//console.log(key, keyPath);
		},
		handleClose(key, keyPath) {
			//console.log(key, keyPath);
		},
		clickGoToPage(item) {
			/*
			if (this.$route.path !== item.path &&
				!(this.$route.path === "home" && item.path === "/")
				) {
				//this.$router.push(item.path);
				this.navigateTo(item.path);
			}*/
			//console.log("item:", item);
			this.navigateTo(item.path);
			this.$store.commit('tab/selectMenu',item);
			// this.$router.push(item.path);
			// 重复点击会报错，屏蔽错误！
			/*
			this.$router.push(item.path).catch(err => {
				if (err.name !== 'NavigationDuplicated') {
					// 处理其他类型的错误
					console.error(err)
				}
			})
			*/
		},
		navigateTo(path) {
			//console.log("this.$route.path:",this.$route.path);
			//console.log("path:",path);
			if (this.$route.path !== path &&
			!(this.$route.path === "home" && path === "/")) {
				this.$router.push(path).catch(err => {
					if (err.name !== 'NavigationDuplicated') {
						console.error('Navigation error:', err);
					}
				});
			}
		},
		hiddenMenu() {
			//document.getElementById("mainAside").style.display = "none";
			document.getElementById("mainAside").classList.toggle('hidden');
			//switchTab("profile");
		},
	},
	computed:{
		get_myMenus_noChildrenTop() {
			//return this.menuData;
			return this.menuData.filter(item => { 
				//if()
				return !item.children && item.top == 1 });
		},
		get_myMenus_noChildren() {
			//return this.menuData;
			return this.menuData.filter(item => { return !item.children && (!item.top || item.top == 0) });
		},
		get_myMenus_hasChildren() {
			//return this.menuData;
			return this.menuData.filter(item => item.children && (item.top == 0 || item.top == 1));
		},
		get_myMenuID(name) {
			//return this.menuData;
			return this.menuData.filter(item.name == name);
		},
		isCollapse() {
			return this.$store.state.tab.isCollapse;
		},
		// 动态获得数据，与原数组 menuData 同名
		menuData() {
			//const curUserMenu = Cookies.get('curUserMenu');
			const curUserMenu = localStorage.getItem('curUserMenu');
			//console.log(curUserMenu);
			if(curUserMenu) {
				const menu = JSON.parse(curUserMenu);

				return menu;
			}
			else
			{
				return false;
			}
		}
	},
	mounted() {
		if(this.$utils.detectDevice()<0)
		{
			document.getElementById("mainAside").classList.toggle('hidden');
		}
	},
	data()
	{
		return {
			//isCollapse: false,
			/*menuData: [
				{
					path: "/m01",
					name: "m01",
					label: "M01菜单",
					icon: "setting",
					url: "/",
				},
				{
					path: "/m02",
					name: "m02",
					label: "M02菜单",
					icon: "setting",
					url: "/",
				},
				{
					path: "/03",
					name: "home",
					label: "03LL",
					icon: "setting",
					url: "/",
				},
				{
					name: "02ll",
					icon: "location",
					label: "02LL",
					children:
					[
						{
							path: "/m01",
							name: "m01",
							label: "M01 项目",
							icon: "setting",
							url: "/m01",
						},
						{
							path: "/m02",
							name: "m02",
							label: "M02 项目",
							icon: "setting",
							url: "/m02",
						},
						{
							path: "/user",
							name: "user",
							label: "用户管理",
							icon: "setting",
							url: "/user",
						},
					],
				},
			]*/
		}
	}
}
</script>
<style lang="less" Scoped>
#h4 {
	padding: 20px;
}

.aside-container {
	box-shadow: 2px 0 10px rgba(0, 0, 0, 0.1);
	background-color: rgba(0, 0, 0, 0.5); 
	width: 100%;
	height: 100%;
	display: flex;
}
.aside-container-menu {
	background: #1e293b;
	width: 100%;
	height: 100%;
	border-right: none;
}

.custom-menu {
	border-right: none;
	
	&:not(.el-menu--collapse) {
		width: 220px;
		min-height: 100%;
	}
}

.menu-header-item {
	height: 64px;
	background: linear-gradient(135deg, #334155 0%, #1e293b 100%) !important;
	border-bottom: 1px solid #334155 !important;
	
	&:hover {
		background-color: #374151 !important;
	}
	
	.header-icon {
		font-size: 20px;
		color: #3b82f6;
		margin-right: 12px;
	}
}

.menu-divider {
	border: none;
	height: 1px;
	background: linear-gradient(90deg, transparent, #475569, transparent);
	margin: 12px 0 0;
}

.custom-menu-item {
	height: 48px;
	line-height: 48px;
	margin: 4px 8px;
	border-radius: 6px;
	transition: all 0.3s ease;
	
	&:hover {
		background-color: #374151 !important;
	}
	
	&.is-active {
		background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%) !important;
		box-shadow: 0 4px 6px -1px rgba(59, 130, 246, 0.3);
		
		.menu-icon {
			color: #fff !important;
		}
		
		.menu-text {
			font-weight: 600;
			color: #ddeeff;
		}
	}
}

.menu-icon {
	font-size: 18px;
	color: #94a3b8;
	margin-right: 12px;
}

.menutree-text {
	font-size: 14px;
	font-weight: 500;
}

.menu-text {
	font-size: 14px;
	font-weight: 500;
}

.custom-submenu {
	margin: 4px 8px;
	
	/deep/ .el-submenu__title {
		height: 48px;
		line-height: 48px;
		border-radius: 6px;
		transition: all 0.3s ease;
		
		&:hover {
			background-color: #374151 !important;
		}
	}
}

.submenu-group {
	padding: 0;
}

.submenu-item {
	height: 40px;
	line-height: 40px;
	margin: 2px 0;
	padding-left: 56px !important;
	border-radius: 4px;
	transition: all 0.2s ease;
	
	&:hover {
		background-color: #374151 !important;
			color: #113366;
	}
	
	&.is-active {
		background-color: rgba(59, 130, 246, 0.15) !important;
		
		.submenu-icon {
			color: #3b82f6 !important;
		}
		
		.submenu-text {
			/* color: #3b82f6; */
			color: #0099ff;
			font-weight: 500;
		}
	}
}

.submenu-icon {
	font-size: 14px;
	color: #94a3b8;
	margin-right: 10px;
}

.submenu-text {
	font-size: 13px;
}

.nulldiv {
	display:none;
}

@media (max-width: 600px) {
	.aside-container-menu {
		background: #1e293b;
		width: 280px;
		min-width: 280px;
		height: 100%;
		box-shadow: 2px 0 10px rgba(0, 0, 0, 0.3);
		overflow: auto;
		overflow-y: auto;
		padding-bottom: 40px;
	}
	
	.custom-menu:not(.el-menu--collapse) {
		width: 280px;
	}
	
	.nulldiv {
		width:100%;
		display: block;
	}
}
</style>